import React from "react"
import styled from "@emotion/styled"
import { injectIntl, Link } from "gatsby-plugin-intl"
import { isBrowser } from "../../../context/ApolloContext"

const ExclusifStickyBannerWrapper = styled.div`
  width: 100%;
  padding: 8px 20px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  background: ${props => props.theme.colors.primary.exclusif};
  color: #fff;
  position: relative;

  @media (max-width: 767px) {
    padding: 5px 10px;
  }
`

const Container = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 0px auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`

const TextWrapper = styled.div`
  width: 100%;
  margin: 0px auto;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
`

const LinkBox = styled(Link)`
  width: 100%;
  position: absolute;
  height: 100%;
  z-index: 1;
`

const LinkButtonTitle = styled.span`
  display: none;
`

const Text = styled.div`
  font-size: 18px;
  line-height: 30px;
  font-family: "Museo";
  font-weight: 500;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  cursor: pointer;

  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
  }
`

const FirstText = styled.div`
  font-size: 28px;
  line-height: 1.2;
  font-family: "BebasNeueBold";
  font-weight: bold;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  span {
    background: #fff;
    color: ${props => props.theme.colors.primary.exclusif};
    font-size: 24px;
    line-height: 1;
    padding: 8px 8px 6px 8px;
    border-radius: 40px;
    margin-left: 10px;

    @media (max-width: 767px) {
      font-size: 18px;
      padding: 5px 5px 5px;
    }

    @media (max-width: 380px) {
      font-size: 16px;
    }
  }

  @media (max-width: 767px) {
    flex-basis: ${({ flexBasis }) => (flexBasis ? "100%" : "auto")};
    justify-content: center;
    font-size: 22px;
  }

  @media (max-width: 380px) {
    font-size: 20px;
  }
`

const SecondText = styled.div`
  font-size: 14px;
  line-height: 1.2;
  display: flex;
  font-family: "Museo";
  font-weight: 500;
  align-items: center;
  margin-left: 15px;

  span {
    font-size: 40px;
    font-family: "BebasNeueBold";
    font-weight: bold;
    margin-right: 10px;
    line-height: 1;

    @media (max-width: 850px) {
      margin-right: 5px;
    }

    @media (max-width: 767px) {
      font-size: 35px;
    }

    @media (max-width: 380px) {
      font-size: 28px;
    }
  }

  strong {
    font-weight: 700;
  }

  @media (max-width: 850px) {
    margin-left: 7px;
  }

  @media (max-width: 767px) {
    margin-left: 0px;
    font-size: 13px;
  }
`

const TextBox = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${({ order }) => (order ? "15px" : "0px")};

  div {
    text-align: left;
  }
`

const FourthText = styled.div`
  font-size: 14px;
  line-height: 1.2;
  display: flex;
  font-family: "Museo";
  font-weight: 500;
  align-items: center;
  margin-left: 7px;

  span:first-of-type {
    font-size: 40px;
    font-family: "BebasNeueBold";
    font-weight: bold;
    margin-right: 7px;
    line-height: 1;

    @media (max-width: 767px) {
      margin-right: 10px;
      font-size: 35px;
    }

    @media (max-width: 380px) {
      font-size: 28px;
    }
  }

  span:nth-of-type(2) {
    background: #fff;
    color: ${props => props.theme.colors.primary.exclusif};
    font-size: 24px;
    line-height: 1;
    font-family: "BebasNeueBold";
    font-weight: bold;
    padding: 8px 8px 6px 8px;
    border-radius: 40px;
    margin-left: 7px;

    @media (max-width: 767px) {
      margin-left: 10px;
      font-size: 20px;
      padding: 5px 5px 5px;
    }

    @media (max-width: 380px) {
      font-size: 16px;
    }
  }

  div {
    text-align: left;
  }

  strong {
    font-weight: 700;
  }

  @media (max-width: 850px) {
    margin-left: 7px;
  }

  @media (max-width: 767px) {
    margin-left: 10px;
    font-size: 13px;
  }
`

const FifthText = styled.div`
  font-size: 14px;
  line-height: 1.2;
  display: flex;
  font-family: "Museo";
  font-weight: 500;
  align-items: center;
  margin-left: 7px;

  span:first-of-type {
    font-size: 40px;
    font-family: "BebasNeueBold";
    font-weight: bold;
    margin-right: 7px;
    line-height: 1;

    @media (max-width: 767px) {
      margin-right: 10px;
      font-size: 35px;
    }

    @media (max-width: 380px) {
      font-size: 28px;
    }
  }

  span:nth-of-type(2) {
    background: #fff;
    color: ${props => props.theme.colors.primary.exclusif};
    font-size: 24px;
    line-height: 1;
    font-family: "BebasNeueBold";
    font-weight: bold;
    padding: 8px 8px 6px 8px;
    border-radius: 40px;
    margin-left: 7px;

    @media (max-width: 767px) {
      margin-left: 10px;
      font-size: 20px;
      padding: 5px 5px 5px;
    }

    @media (max-width: 380px) {
      font-size: 16px;
    }
  }

  div {
    text-align: left;
  }

  strong {
    font-weight: 700;
  }

  @media (max-width: 850px) {
    margin-left: 7px;
  }

  @media (max-width: 767px) {
    font-size: 13px;
  }
`

const ExclusifNewStickyBanner = ({ intl }) => {
  var currentPath = ""

  let isOreillerPage = false
  let isMatelasPage = false
  let isSurmatelasPage = false
  let isSommierPage = false
  let isSoutienPage = false
  let isLynePage = false
  let isSolutionPage = false
  let isChaisePage = false

  let oreillerRegex = /(oreiller|oreillers-ergonomiques)/
  let matelasRegex = /(matelas)/
  let surmatelasRegex = /(surmatelas)/
  let sommierRegex = /(sommier|lit-electrique)/
  let soutienRegex = /(soutien-gorge)/
  let lyneRegex = /(tshirt-discret|gilet-pratique|tshirt-sport)/
  let solutionRegex = /(solutions-textiles|wearable-technology)/
  let chaiseRegex = /(chaise-bureau-ergonomique)/

  if (isBrowser) {
    currentPath = window.location.pathname

    isOreillerPage = oreillerRegex.test(currentPath)
    isMatelasPage = matelasRegex.test(currentPath)
    isSurmatelasPage = surmatelasRegex.test(currentPath)
    isSommierPage = sommierRegex.test(currentPath)
    isSoutienPage = soutienRegex.test(currentPath)
    isLynePage = lyneRegex.test(currentPath)
    isSolutionPage = solutionRegex.test(currentPath)
    isChaisePage = chaiseRegex.test(currentPath)
  }

  return (
    <ExclusifStickyBannerWrapper
      lang={intl.locale}
      className="LyneHomeStickyBanner"
    >
      <Container>
        {isSurmatelasPage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText>Profitez aujourd'hui :</FirstText>
              <FourthText>
                <span>-25%</span>
                <div>
                  <strong>sur le surmatelas</strong>
                </div>
              </FourthText>
            </Text>
          </TextWrapper>
        ) : isChaisePage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText>Profitez aujourd'hui :</FirstText>
              <FourthText>
                <span>-120€</span>
                <div>
                  <strong>sur la chaise ergonomique</strong>
                </div>
              </FourthText>
            </Text>
          </TextWrapper>
        ) : isMatelasPage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText>Profitez aujourd'hui :</FirstText>
              <FourthText>
                <span>-35%</span>
                <div>
                  <strong>sur les packs matelas + oreiller</strong>
                </div>
              </FourthText>
            </Text>
          </TextWrapper>
        ) : isOreillerPage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText>Profitez aujourd'hui :</FirstText>
              <FourthText>
                <span>-35%</span>
                <div>
                  <strong>sur les packs 3 oreillers</strong>
                </div>
              </FourthText>
            </Text>
          </TextWrapper>
        ) : isSommierPage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText>Profitez aujourd'hui :</FirstText>
              <FourthText>
                <span>-40%</span>
                <div>
                  <strong>sur les packs matelas + sommier</strong>
                </div>
              </FourthText>
            </Text>
          </TextWrapper>
        ) : isLynePage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText flexBasis="100%">Profitez aujourd'hui :</FirstText>
              <SecondText>
                <TextBox>
                  <span>-20€</span>
                  <div>
                    sur <strong>1 T-shirt</strong>
                  </div>
                </TextBox>
                <TextBox order={2}>
                  <span>-80€</span>
                  <div>
                    sur <strong>2 T-shirts</strong>
                  </div>
                </TextBox>
              </SecondText>
            </Text>
          </TextWrapper>
        ) : isSoutienPage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText flexBasis="100%">Profitez aujourd'hui :</FirstText>
              <SecondText>
                <TextBox>
                  <span>-10€</span>
                  <div>
                    sur <strong>1 soutien-gorge</strong>
                  </div>
                </TextBox>
                <TextBox order={2}>
                  <span>-40€</span>
                  <div>
                    sur <strong>2 soutiens-gorge</strong>
                  </div>
                </TextBox>
              </SecondText>
            </Text>
          </TextWrapper>
        ) : isSolutionPage ? (
          <TextWrapper>
            <Text lang={intl.locale}>
              <FirstText flexBasis="100%">Profitez aujourd'hui :</FirstText>
              <SecondText>
                <div style={{ marginRight: 7 }}>
                  <strong>Jusqu’à</strong>
                </div>
                <TextBox>
                  <span>-20€</span>
                  <div>
                    sur <strong>1 T-shirt</strong>
                  </div>
                </TextBox>
                <TextBox order={2}>
                  <span>-80€</span>
                  <div>
                    sur <strong>2 T-shirts</strong>
                  </div>
                </TextBox>
              </SecondText>
            </Text>
          </TextWrapper>
        ) : (
          <TextWrapper>
            <LinkBox to="/shop/offres-exclusives/">
              <LinkButtonTitle>Je découvre</LinkButtonTitle>
            </LinkBox>
            <Text lang={intl.locale}>
              <FirstText>Profitez aujourd'hui :</FirstText>
              <FifthText>
                <div style={{ marginRight: 7 }}>
                  <strong>Jusqu’à</strong>
                </div>
                <span>-40%</span>
              </FifthText>
            </Text>
          </TextWrapper>
        )}
      </Container>
    </ExclusifStickyBannerWrapper>
  )
}

export default injectIntl(ExclusifNewStickyBanner)
